import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { SelectPesquisavelComponent } from '../../../../../shared/components/select-pesquisavel/select-pesquisavel.component';
import { AlertCardComponent } from '../../../../../shared/components/alert-card/alert-card.component';
import { AlertService, AlertType } from '../../../../../shared/services/alert.service';
import { ProdutoService } from '../../../../../shared/services/apis/produto/produto.service';
import { LookupItemStruct } from '../../../../../shared/services/structs/pessoa/lookup-item.struct';
import { UnidadeMedidaStruct } from '../../../../../shared/services/structs/produto/unidade-medida.struct';
import { ProdutoBulkEditRequest } from '../../../../../shared/services/requests/produto/produto-bulk-edit.request';
import { environment } from '../../../../../../environments/environment';
import { TipoContatoEnum } from '../../../../../shared/enums/pessoa/tipo-contato.enum';
import { Masks, MaskService } from '../../../../../shared/services/mask.service';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { NgxCurrencyDirective } from 'ngx-currency';

export interface EditarProdutosMassaDialogData {
  listaProdutoIds: number[];
  listaUnidadeMedida: UnidadeMedidaStruct[];
  listaOrigemMercadoria: LookupItemStruct[];
  listaCategoria: LookupItemStruct[];
  listaMarca: LookupItemStruct[];
  listaLinhaProduto: LookupItemStruct[];
  listaTipoItemSped: LookupItemStruct[];
}

@Component({
  selector: 'app-editar-produtos-massa-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    SelectPesquisavelComponent,
    AlertCardComponent,
    NgxMaskDirective,
    NgxCurrencyDirective,
    MatProgressSpinnerModule,
  ],
  providers: [provideNgxMask()],
  templateUrl: './editar-produtos-massa-dialog.component.html',
  styleUrl: './editar-produtos-massa-dialog.component.css',
})
export class EditarProdutosMassaDialogComponent implements OnInit {
  public form!: FormGroup;
  public isLoading: boolean = false;
  public urlFornecedor = `${environment.urlApiPessoa}Lookup/listPessoaSelect?idTipoContato=${TipoContatoEnum.Fornecedor}`;
  public masks = MaskService.getMasks();
  public maskDecimal2: any;
  public opcoesBooleano = [
    { value: true, descricao: 'Sim' },
    { value: false, descricao: 'Não' },
  ];

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<EditarProdutosMassaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditarProdutosMassaDialogData,
    private produtoService: ProdutoService,
    private alertService: AlertService,
    private maskService: MaskService
  ) {
    this.maskDecimal2 = this.maskService.getDecimalMask2();
    this.maskDecimal2.suffix = ' %';
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      idUnidadeMedida: [null],
      ncm: [null],
      cest: [null],
      idOrigemMercadoria: [null],
      idCategoria: [null],
      idFornecedor: [null],
      idMarca: [null],
      garantiaTexto: [null],
      idLinhaProduto: [null],
      idTipoItemSped: [null],
      isPermitirVenda: [null],
      markupPadrao: [null],
      isAtivo: [null],
    });
  }

  public aplicar(): void {
    if (this.isLoading) return;

    const rawValues = this.form.getRawValue();
    const payload: ProdutoBulkEditRequest = {
      idsProduto: this.data.listaProdutoIds,
    };

    let hasChanges = false;

    // Apenas preenche no payload propriedades que não estão nulas ou vazias
    Object.keys(rawValues).forEach(key => {
      const value = rawValues[key];
      if (value !== null && value !== undefined && value !== '') {
        (payload as any)[key] = value;
        hasChanges = true;
      }
    });

    if (!hasChanges) {
      this.alertService.show('Aviso', 'Nenhuma alteração foi informada.', AlertType.warning);
      return;
    }

    this.isLoading = true;
    this.produtoService.editarEmMassa(payload).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if (res.isError) {
          this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
          return;
        }
        this.alertService.show('Sucesso', 'Produtos atualizados com sucesso.', AlertType.success);
        this.dialogRef.close({ success: true });
      },
      error: (err: any) => {
        this.isLoading = false;
        this.alertService.show('Erro', 'Ocorreu um erro ao atualizar os produtos.', AlertType.error);
      },
    });
  }

  public cancelar(): void {
    this.dialogRef.close();
  }
}
